import type { EstadoLoteSep } from '../services/api';

export const ROLES_RECEPCION_LOTE = ['MESA_ENTRADAS', 'ANALISTA', 'SUPERVISOR', 'AUTORIDAD_FIRMANTE', 'ADMINISTRADOR'];
export const ROLES_APERTURA_LOTE = ['ANALISTA', 'SUPERVISOR', 'AUTORIDAD_FIRMANTE', 'ADMINISTRADOR'];

export const ESTADO_LOTE_SEP: Record<EstadoLoteSep, { etiqueta: string; clase: string }> = {
  PRESENTADO: { etiqueta: 'Esperando las fichas en papel', clase: 'badge-warning' },
  FICHAS_RECIBIDAS: { etiqueta: 'Listo para verificar', clase: 'badge-info' },
  EN_VERIFICACION: { etiqueta: 'En verificación', clase: 'badge-primary' },
  EN_SUBSANACION: { etiqueta: 'En subsanación', clase: 'badge-danger' },
  RESUELTO: { etiqueta: 'Resuelto', clase: 'badge-success' },
};

export const ETIQUETA_SUPUESTO_LOTE: Record<string, string> = {
  FICHAS_AFILIACION_ART_20: 'Fichas de afiliación (Art. 20)',
  REGISTRO_AFILIADOS_ART_32: 'Registro de afiliados (Art. 32)',
};

export const ETIQUETA_CONTROL: Record<string, string> = {
  VALIDO: 'Sin observaciones',
  NO_ENCONTRADO: 'No está en el padrón',
  EXTRANJERO: 'Padrón de extranjeros',
  LOCALIDAD_NO_COINCIDE: 'Localidad no coincide',
  DUPLICADO_OTRO_PARTIDO: 'Afiliado en otro partido',
  DUPLICADO_VALIDO: 'Duplicado válido',
  DUPLICADO_INVALIDO: 'Duplicado inválido',
  DUPLICADO_DISTRITAL: 'Duplicado distrital',
  EXCLUIDO_LEGAL: 'Impedimento legal',
  APROBADO_MANUAL: 'Aprobado manual',
};

export function desplazaAOtroPartido(resultadoControl: string): boolean {
  return resultadoControl === 'DUPLICADO_VALIDO';
}

export function diasDesde(fecha: string | null): number | null {
  if (!fecha) return null;
  const inicio = new Date(fecha.slice(0, 10) + 'T00:00:00');
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((hoy.getTime() - inicio.getTime()) / 86_400_000));
}

export function claseDemora(dias: number): string {
  if (dias >= 20) return 'bg-red-50 text-red-700 ring-red-200';
  if (dias >= 10) return 'bg-amber-50 text-amber-700 ring-amber-200';
  return 'bg-gray-50 text-gray-600 ring-gray-200';
}
